import { ArrowUp, Facebook, Phone, Mail } from "lucide-react";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-slate-950 text-white py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_joinery-landing/artifacts/nlxukwpp_wa-logo-white.png"
                alt="J. Antrobus & Son"
                className="h-16 w-auto mb-2"
              />
              <span className="block font-heading font-bold text-lg text-white mb-1">
                J Antrobus & Son
              </span>
              <span className="block font-mono text-xs text-slate-500 uppercase tracking-widest">
                Est. 1993
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Family-run building and joinery contractors serving Southport, 
              Merseyside, and Lancashire for over 30 years.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/jantrobusandson"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 flex items-center justify-center bg-slate-800 hover:bg-royal transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              {[
                "Home Extensions",
                "Conservatories",
                "uPVC Windows & Doors",
                "Kitchens",
                "Roofing",
                "Joinery",
              ].map((service) => (
                <li key={service}>
                  <a
                    href="#services"
                    className="text-slate-400 text-sm hover:text-white transition-colors"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider mb-6">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                href="tel:07803602247"
                className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
              >
                <Phone size={16} />
                <span className="text-sm">07803 602247</span>
              </a>
              <a
                href="mailto:wantrobus@hotmail.co.uk"
                className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
              >
                <Mail size={16} />
                <span className="text-sm">wantrobus@hotmail.co.uk</span>
              </a>
            </div>
            
            {/* Accreditations */}
            <div className="mt-8">
              <h4 className="font-mono text-xs text-slate-500 uppercase tracking-wider mb-4">
                Our Promise
              </h4>
              <div className="flex flex-wrap gap-3">
                {["Fully Insured", "100% Satisfaction", "Quality Materials"].map((badge) => (
                  <span
                    key={badge}
                    className="px-3 py-1.5 bg-slate-800 border border-slate-700 font-mono text-xs text-slate-400"
                  >
                    {badge}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-slate-800 mb-8" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-slate-500 text-sm text-center md:text-left">
            <span>© {currentYear} J Antrobus & Son is a trading name of Wayne Antrobus Limited.</span>
            <span className="block md:inline md:ml-2">Company Registration Number: 16775970</span>
            <span className="block mt-1">Website design by <a href="https://www.barton.uk" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">www.barton.uk</a></span>
          </div>
          
          {/* Back to Top */}
          <button
            onClick={scrollToTop}
            data-testid="back-to-top"
            className="flex items-center gap-2 text-slate-500 hover:text-white transition-colors text-sm"
            aria-label="Back to top"
          >
            <span>Back to top</span>
            <ArrowUp size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
};
